"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadSlotProgressBar = exports.Attachment = void 0;
var React = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var axios_1 = __importDefault(require("axios"));
axios_1.default.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
var useEffect = React.useEffect, useRef = React.useRef, useContext = React.useContext, useState = React.useState, useCallback = React.useCallback;
exports.Attachment = function (props) {
    var _a, _b;
    var onUpload = props.onUpload, _c = props.isButton, isButton = _c === void 0 ? false : _c;
    var _d = useState([]), files = _d[0], setFiles = _d[1];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = useState(""), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(false), isUploaded = _g[0], setIsUploaded = _g[1];
    var _h = useState(0), barValue = _h[0], setBarValue = _h[1];
    var mounted = useRef(false);
    useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    var onDrop = useCallback(function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadedFiles, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (acceptedFiles.length === 0) {
                        return [2 /*return*/];
                    }
                    uploadedFiles = acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.map(function (f) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, endpoint, res_1, error_1;
                        var _a, _b, _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append("file", f);
                                    endpoint = "/sfapi/customer-artwork-library/upload";
                                    _d.label = 1;
                                case 1:
                                    _d.trys.push([1, 3, , 4]);
                                    setIsSubmitting(true);
                                    setErrorMessage("");
                                    return [4 /*yield*/, axios_1.default(endpoint, {
                                            method: "POST",
                                            data: formData,
                                            headers: {
                                                "Content-Type": "multipart/form-data"
                                            },
                                            onUploadProgress: function (progressEvent) {
                                                var loaded = progressEvent.loaded, total = progressEvent.total;
                                                var percent = Math.floor((loaded * 100) / total);
                                                if (percent < 100) {
                                                    if (percent < 5) {
                                                        percent = 5;
                                                    }
                                                    setBarValue(percent);
                                                }
                                            }
                                        })];
                                case 2:
                                    res_1 = _d.sent();
                                    if (res_1) {
                                        setTimeout(function () {
                                            setBarValue(100);
                                        }, 50);
                                        setIsUploaded(true);
                                        setTimeout(function () {
                                            setIsUploaded(false);
                                        }, 2000);
                                        return [2 /*return*/, (_c = (_b = (_a = res_1 === null || res_1 === void 0 ? void 0 : res_1.data) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.files) === null || _c === void 0 ? void 0 : _c[0]];
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _d.sent();
                                    setIsUploaded(false);
                                    setIsSubmitting(false);
                                    setErrorMessage("Upload fail. Please try again");
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadedFiles).then(function (res) {
                            setIsSubmitting(false);
                            setBarValue(0);
                            return res;
                        })];
                case 1:
                    res = _a.sent();
                    if (res && mounted.current) {
                        onUpload(res);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var _j = react_dropzone_1.useDropzone({
        onDrop: onDrop,
        accept: " .pdf, .jpg, .jpeg, .tif, .tiff",
        maxSize: 350000000
    }), getRootProps = _j.getRootProps, getInputProps = _j.getInputProps, isDragActive = _j.isDragActive;
    var rootProps = getRootProps();
    var uploadMessage = "Hang tight - we're uploading your masterpiece";
    if (barValue > 25 && barValue < 75) {
        uploadMessage = "Nearly there! We're rendering your artwork file";
    }
    else if (barValue > 74) {
        uploadMessage = "Almost done - we're updating your Artwork Library";
    }
    return (React.createElement(React.Fragment, null,
        isButton ? (React.createElement("div", __assign({}, rootProps, { className: props.btnClassName || "btn btn-outline-secondary" }),
            "Replace",
            React.createElement("input", __assign({}, getInputProps({
                multiple: (_a = props === null || props === void 0 ? void 0 : props.isMultiple) !== null && _a !== void 0 ? _a : false
            }), { disabled: props.isDisable })))) : (React.createElement("div", __assign({}, rootProps, { className: "py-5 text-center mb-3 border border-dark rounded txc-pink " + (isDragActive &&
                "border-success") + " " + props.className }),
            React.createElement("div", { className: "mb-3" },
                React.createElement("i", { className: "fas fa-file-upload  fa-4x" })),
            isSubmitting ? (React.createElement("p", null, uploadMessage)) : (React.createElement("p", null, "Drag and drop or click to upload")),
            React.createElement("input", __assign({}, getInputProps({
                multiple: (_b = props === null || props === void 0 ? void 0 : props.isMultiple) !== null && _b !== void 0 ? _b : false
            }), { disabled: props.isDisable })))),
        !isSubmitting && errorMessage && (React.createElement("div", { className: "alert alert-danger" }, errorMessage)),
        isSubmitting && React.createElement(exports.UploadSlotProgressBar, { barValue: barValue })));
};
exports.UploadSlotProgressBar = function (props) {
    var barValue = props.barValue;
    return (React.createElement("div", { className: "progress mt-3" },
        React.createElement("div", { className: "progress-bar progress-bar-striped progress-bar-animated", role: "progressbar", "aria-valuenow": barValue, "aria-valuemin": 6, "aria-valuemax": 100, style: { width: barValue + "%" } },
            React.createElement("span", { className: "sr-only" },
                barValue,
                "% complete"))));
};
